import React, { useState, useEffect, useContext} from 'react';
import MUIDataTable from 'mui-datatables';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
    Card,
    Stack,
    Container,
    Typography,
    MenuItem,  
    ListItemIcon, 
    ListItemText,
  } from '@mui/material';

import {api, reiniciarToken, consUsuario} from '../../services/api';
// context
import { AuthContext } from '../../contexts/auth';  

import Page from '../../components/Page';
import Iconify from '../../components/Iconify';

export default function ConsultaUsuario() {
  
  const { logout } = useContext(AuthContext);
  const [dados, setData] = useState([]);

  const getUsuarios = async () => {
    
    const retorno = await reiniciarToken();
    if(retorno.erro === true) {
      if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
        logout();
      }
    }else{
      localStorage.setItem("token", retorno.data.token);
      api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
    }

    const response = await consUsuario();
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      response.data.forEach((valores) => {
        const descricaoEmpresa = valores.empresa?.descricao;
        const descricaoAcesso = valores.acesso_permitido === 1 ? "Liberado" : "Sem Permissão";
        const pefilAcesso = valores.menu_restrito === 1 ? "Sim" : "Não";

        setData(dados => [...dados, {usuario: valores.usuario, 
                                     email: valores.email, 
                                     acesso_permitido: descricaoAcesso, 
                                     descricao_empresa: descricaoEmpresa,
                                     menu_restrito: pefilAcesso}]);
      });
    }; 
  }

  useEffect(() => {
    getUsuarios();
  },[]) 
  
  const columns = [{name: "Ação",
                    options: {
                      filter: false,
                      sort: false,
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <MenuItem component={RouterLink} to={`/usuarios/editar/${dados[dataIndex].usuario}`} sx={{ color: 'text.secondary' }}>
                              <ListItemIcon>
                                  <Iconify icon="eva:edit-fill" width={24} height={24} />
                              </ListItemIcon>
                              <ListItemText primary="Alterar" primaryTypographyProps={{ variant: 'body2' }} />
                            </MenuItem>
                          </> 
                        );
                      }
                    }
                  }
                  ,{name:"usuario", label: "Usuário"} 
                  ,{name:"email", label: "E-mail"}
                  ,{name:"acesso_permitido", label: "Permissão de Acesso"}
                  ,{name:"menu_restrito", label: "Perfil Restrito"}
                  ,{name:"descricao_empresa", label: "Empresa"}
                  ];

  const options = {
    filterType: "dropdown",
    tableBodyHeight: "100%",
    selectableRows: "none",
    responsive: "standard",
  };             
                    
  return (
    <Page title="Usuário">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Consulta de Usuário
          </Typography>
        </Stack>
        <Card>
          <MUIDataTable
              data={Object.values(dados)}
              columns={columns}  
              options={options} 
          />
        </Card>
      </Container>  
    </Page>  
  );
}

